
export enum RuleGroup {
  Accept = 1,
  Alert = 2
}
